import { render, staticRenderFns } from "./BottomNavigationList.vue?vue&type=template&id=02156d9c&scoped=true&"
import script from "./BottomNavigationList.vue?vue&type=script&lang=js&"
export * from "./BottomNavigationList.vue?vue&type=script&lang=js&"
import style0 from "./BottomNavigationList.vue?vue&type=style&index=0&id=02156d9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02156d9c",
  null
  
)

export default component.exports